import BaseDB from 'libs/DB/BaseDB'

export const outboxDB = new BaseDB('outboxDB', {
  version: 1,
  key: 'id',
  dataKey: 'data',
  autoInit: false,
  expireDuration: 7 * 24 * 60 * 60 * 1000,
})

export const attachmentDB = new BaseDB('outboxAttachmentDB', {
  version: 1,
  key: 'id',
  dataKey: 'blob',
  expireDuration: 7 * 24 * 60 * 60 * 1000,
  skipPreload: true,
})

const ret = {
  outboxDB,
  attachmentDB,
}

export default ret
